import { render, staticRenderFns } from "./BeforePay.vue?vue&type=template&id=af22e434&scoped=true&"
import script from "./BeforePay.vue?vue&type=script&lang=js&"
export * from "./BeforePay.vue?vue&type=script&lang=js&"
import style0 from "./BeforePay.vue?vue&type=style&index=0&id=af22e434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22e434",
  null
  
)

export default component.exports